// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file catpocs/v1/deployments.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import { DeploymentService } from "./deployments_pb";

/**
 * ListImageTags lists available image tags from ECR for an application
 *
 * @generated from rpc catpocs.v1.DeploymentService.ListImageTags
 */
export const listImageTags = DeploymentService.method.listImageTags;

/**
 * GetImageDeployments gets deployment history for an application
 *
 * @generated from rpc catpocs.v1.DeploymentService.GetImageDeployments
 */
export const getImageDeployments = DeploymentService.method.getImageDeployments;

/**
 * DeployImageTag deploys a specific image tag
 *
 * @generated from rpc catpocs.v1.DeploymentService.DeployImageTag
 */
export const deployImageTag = DeploymentService.method.deployImageTag;

/**
 * GetDeploymentStatus gets the status of a deployment
 *
 * @generated from rpc catpocs.v1.DeploymentService.GetDeploymentStatus
 */
export const getDeploymentStatus = DeploymentService.method.getDeploymentStatus;

/**
 * ConfigureTagTracking configures watched tag behavior for an application
 *
 * @generated from rpc catpocs.v1.DeploymentService.ConfigureTagTracking
 */
export const configureTagTracking = DeploymentService.method.configureTagTracking;
